import React from 'react';
import cssaLogo from '../assets/cssa-logo.png';

const Safeguarding: React.FC = () => {
  return (
    <div className="min-h-screen bg-church-light">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif font-bold text-church-blue mb-4">
            Safeguarding
          </h1>
          <p className="text-lg text-gray-700">
            Protecting children, young people and adults at risk
          </p>
        </div>

        {/* CSSA Logo */}
        <div className="text-center mb-8">
          <img 
            src={cssaLogo} 
            alt="Catholic Safeguarding Standards Agency" 
            className="mx-auto h-24 w-auto"
          />
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Parish Safeguarding Representative */}
            <div className="bg-church-light p-6 rounded-lg">
              <h2 className="text-2xl font-serif font-bold text-church-blue mb-4">
                Your Safeguarding Representative
              </h2>
              <div className="space-y-3">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">
                    Cathryn O'Donovan
                  </h3>
                </div>
                <div>
                  <p className="text-gray-700">
                    <strong>Email:</strong>{' '}
                    <a 
                      href="mailto:psrallsaints@rcdmidd.org.uk"
                      className="text-church-blue hover:text-church-gold transition-colors"
                    >
                      psrallsaints@rcdmidd.org.uk
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Diocesan Coordinator */}
            <div className="bg-church-light p-6 rounded-lg">
              <h2 className="text-2xl font-serif font-bold text-church-blue mb-4">
                Diocesan Safeguarding Coordinator
              </h2>
              <div className="space-y-3">
                <div>
                  <p className="text-gray-700">
                    <strong>Phone:</strong>{' '}
                    <a 
                      href="tel:01642850505"
                      className="text-church-blue hover:text-church-gold transition-colors"
                    >
                      01642 850505
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Role Description */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-serif font-bold text-church-blue mb-4">
            Your Safeguarding Representative
          </h2>
          <p className="text-gray-700 leading-relaxed">
            The Safeguarding representative has special responsibility for promoting good and safe 
            practices in all activities involving children, young people and adults at risk.
          </p>
        </div>

        {/* Find Out More */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-serif font-bold text-church-blue mb-4">
            Find Out More
          </h2>
          <div className="space-y-3">
            <div>
              <a 
                href="https://www.catholicsafeguarding.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-church-blue hover:text-church-gold transition-colors font-medium"
              >
                www.catholicsafeguarding.org.uk
              </a>
            </div>
            <div>
              <a 
                href="https://www.diocesanwebsite.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-church-blue hover:text-church-gold transition-colors font-medium"
              >
                www.diocesanwebsite.org.uk
              </a>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="mt-8 text-center">
          <p className="text-gray-600 text-sm">
            If you have any safeguarding concerns, please contact our Safeguarding Representative 
            or the Diocesan Safeguarding Coordinator immediately.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Safeguarding;